/**
 * Attribute helper treating any value except `null` and `'false'` as enabled.
 */
export function parseBooleanAttribute(value: string | null): boolean {
	return value !== null && value !== 'false'
}
